import * as types from '../Actions/types';

const INIT_STATE = {
    formURL : null
}

const Delivery = (state = INIT_STATE , action) => {
    switch(action.type) {
        case types.FORM_URL: 
            return {
                formURL: action.formURL
            }

        default:
            return state;
    }
}

export default Delivery;